import React from 'react';
import Button from 'Components/Atoms/Button';
import Box from 'Components/Atoms/Box';
import { Lock, Clear, LockOpen } from 'Components/Atoms/Icons';
import TotalReservationsTerraceButton from './TotalReservationsTerraceButton';
import useProtectedAction from 'utils/useProtectedAction';
import { GateActivity, SecurityGrant } from 'CustomHooks/usePinAuth';

// The button only starts the open/close flow (a dialog or the shift's own
// protected action), so it is logged as that request, not as a change.
const REQUEST_ACTIVITY: GateActivity = { action: 'day.reservationsDialog', category: 'form' };

export type TotalReservationsProps = {
  closed: boolean;
  /** `grant`: the Security Plus PIN of this button, for the dialog's later save. */
  onAction: (type: 'terrace' | 'close', grant?: SecurityGrant) => void;
  fullWidth?: boolean;
  margin?: string;
};

const TotalReservationsResButton = ({
  closed,
  onAction,
  fullWidth = false,
  margin,
}: TotalReservationsProps) => {
  const protectedAction = useProtectedAction();

  return (
    <>
      {!closed ? (
        <Button
          fullWidth={fullWidth}
          onClick={() => {
            protectedAction(
              'chefWaiter',
              '',
              (grant) => {
                onAction('close', grant);
              },
              'reservations.blockedTime.write',
              REQUEST_ACTIVITY
            );
          }}
          variant="outlined"
          endIcon={() => (
            <Lock
              style={{ color: 'var(--color-critical)', alignSelf: 'center' }}
            />
          )}
          typographyProps={{
            variant: 'text-2',
            style: { color: 'var(--color-critical)' },
          }}
          translation="reservations"
          style={{ borderColor: 'var(--color-critical)', margin: margin }}
        >
          Close Reservation
        </Button>
      ) : (
        <Button
          fullWidth={fullWidth}
          onClick={() => {
            protectedAction(
              'chefWaiter',
              '',
              (grant) => {
                onAction('close', grant);
              },
              'reservations.blockedTime.write',
              REQUEST_ACTIVITY
            );
          }}
          variant="outlined"
          endIcon={() => (
            <LockOpen
              style={{ color: 'var(--color-primary)', alignSelf: 'center' }}
            />
          )}
          typographyProps={{
            variant: 'text-2',
            style: { color: 'var(--color-primary)' },
          }}
          translation="reservations"
          style={{
            borderColor: 'var(--color-primary)',
            margin: margin,
          }}
        >
          Open Reservation
        </Button>
      )}
    </>
  );
};

export default TotalReservationsResButton;
